import app from './../index';

export default class RequestQuoteController {

  constructor($scope) {
    'ngInject';

    this.scope = $scope;
    this.kontakt = app.kontakt;
    this.artikel = app.artikel;
  }

  submit() {
    this.scope.$broadcast('show-errors-check-validity');

    if (this.scope.form.$invalid) {
      return;
    }

    const anfrage = {
      kontakt: this.kontakt,
      artikel: app.artikel.map(a => {
        return {
          artikelId: a.Id,
          menge: a.menge
        };
      })
    };

    app.api.anfragen.save(anfrage, () => {
      app.$location.path('/requestQuoteSuccess');
    });
  }
}

RequestQuoteController.$inject = ['$scope'];



/** WEBPACK FOOTER **
 ** ./public/app/artikel/requestQuoteController.js
 **/